import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import FontFaceObserver from "fontfaceobserver";
import { listEvents } from "../../utils/api/helpers/events";
import EventListItem from "./components/EventListItem";
import fysee26LogoColor from "../../assets/img/fysee/FYSEE_Logo_Fall2026.png";


export default function EventList() {
  const [fontLoaded, setFontLoaded] = useState(false);
  const [allEvents, setAllEvents] = useState(null);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    setFontLoaded(false);
    const font = new FontFaceObserver("NetflixSansCond");

    font
      .load()
      .then(() => {
        setTimeout(() => {
          setFontLoaded(true);
        }, 500);
      })
      .catch(() => {
        console.error("Font failed to load");
        setFontLoaded(true); // fallback anyway
      });
  }, []);

  useEffect(() => {
    listEvents()
      .then((res) => {
        // console.log(res);
        setAllEvents(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <div className="events-page-container w-100 text-white">
        <Helmet>
          <title>{"Events | Netflix Series FYC"}</title>
          <meta name="description" content={"Events | Netflix Series FYC"} />
        </Helmet>

        <div
          className="events-page-content w-100"
          style={{ opacity: fontLoaded ? 1 : 0 }}
        >
          {/*<div className="page-divider" />*/}
          <div className="width-ctrl">
            <div className="w-100 d-flex align-items-center justify-content-center mb-5 px-4">
              <img
                src={fysee26LogoColor}
                alt={"FYSEE"}
                className={"w-100"}
                style={{ maxWidth: 600 }}
              />
            </div>
            <div className={"events-grid pt-4 text-white"}>
              {allEvents === null ? (
                <div className="mt-5 d-flex align-items-center justify-content-center nf-sans-cond w-100">
                  <h1 className="fw-bold">Loading Events...</h1>
                </div>
              ) : allEvents.length === 0 ? (
                <div className="mt-5 d-flex align-items-center justify-content-center nf-sans-cond w-100">
                  <h1 className="fw-bold">Check back soon for more events!</h1>
                </div>
              ) : (
                allEvents.map((o, i) => (
                  <EventListItem key={o.slug} i={i} event_object={o} />
                ))
              )}
            </div>
          </div>
        </div>
      </div>

      <div
        className="position-fixed z-0 w-100 h-100"
        style={{ top: 0, left: 0, background: "#1a1a1a" }}
      />
      <div className="events-page-background-gradient" />
    </>
  );
}
